import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Menu, Close } from "@carbon/icons-react";

import LogoTagaNow from "@/assets/images/taganow-logo-color.svg";
import { Button } from "@/components/ui/button";
import { LIBRARY_URL } from "@/config/api";

const Header: React.FC = () => {
  const navigate = useNavigate();

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 10) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleMobileMenuToggle = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const navigationItems = [
    { label: "Sản phẩm", href: "#*" },
    { label: "Quy trình mẫu", href: "#*" },
    { label: "Khách hàng", href: "#*" },
    { label: "Tải xuống", href: "/download" },
    { label: "Bảng giá", href: "#*" },
    { label: "Taga Studio", href: `${LIBRARY_URL}/studio`, external: true },
  ];

  return (
    <div className="w-full box-border mx-auto !max-w-[1672px] !px-3 sm:!px-6 2xl:!px-9 fixed left-0 right-0 top-3 sm:top-5 z-50 mx-auto">
      <header
        className={`w-full rounded-lg border transition-all duration-300 bg-white/90 backdrop-blur-sm  ${
          isScrolled ? " border-gray-100/50" : "border-transparent"
        }`}
      >
        <div className="mx-auto p-2 sm:p-2">
          <div className="flex items-center justify-between">
            {/* Logo */}
            <div className="flex items-center">
              <a
                href="/home"
                className="text-black font-bold text-xl flex items-center"
              >
                <img
                  src={LogoTagaNow}
                  alt="logo"
                  className="h-6 sm:h-8"
                />
              </a>
            </div>

            {/* Desktop Navigation Links */}
            <nav className="hidden lg:flex items-center space-x-6 xl:space-x-8 text-gray-700">
              {navigationItems.map((item) => (
                <a
                  key={item.label}
                  href={item.href}
                  target={item.external ? "_blank" : undefined}
                  rel={item.external ? "noreferrer" : undefined}
                  className="text-sm xl:text-base hover:text-gray-900 transition-colors"
                >
                  {item.label}
                </a>
              ))}
            </nav>

            {/* Right side buttons */}
            <div className="flex items-center space-x-2 sm:space-x-4">
              <Button
                className="hidden sm:block text-sm"
                variant="text"
                onClick={() => navigate("/login")}
              >
                Đăng nhập
              </Button>
              <Button
                className="bg-black text-white h-8 sm:h-10 text-sm px-3 sm:px-4"
                onClick={() => navigate("/login")}
              >
                Đăng ký
              </Button>

              {/* Mobile menu button */}
              <button
                className="lg:hidden p-2 text-gray-700 hover:text-gray-900 transition-colors"
                onClick={handleMobileMenuToggle}
                aria-label="Toggle mobile menu"
              >
                {isMobileMenuOpen ? <Close size={24} /> : <Menu size={24} />}
              </button>
            </div>
          </div>

          {/* Mobile Navigation Menu */}
          {isMobileMenuOpen && (
            <div className="lg:hidden mt-4 pb-4 border-t border-gray-100">
              <nav className="flex flex-col space-y-3 pt-4">
                {navigationItems.map((item) => (
                  <a
                    key={item.label}
                    href={item.href}
                    target={item.external ? "_blank" : undefined}
                    rel={item.external ? "noreferrer" : undefined}
                    className="text-gray-700 hover:text-gray-900 transition-colors py-2 px-4 rounded-lg hover:bg-gray-50"
                    onClick={() => setIsMobileMenuOpen(false)}
                  >
                    {item.label}
                  </a>
                ))}
                <div className="pt-3 border-t border-gray-100 mt-3">
                  <Button
                    className="w-full mb-3 text-sm"
                    variant="text"
                    onClick={() => {
                      navigate("/login");
                      setIsMobileMenuOpen(false);
                    }}
                  >
                    Đăng nhập
                  </Button>
                  <Button
                    className="w-full bg-black text-white text-sm"
                    onClick={() => {
                      navigate("/login");
                      setIsMobileMenuOpen(false);
                    }}
                  >
                    Đăng ký
                  </Button>
                </div>
              </nav>
            </div>
          )}
        </div>
      </header>
    </div>
  );
};

export default Header;
